import React, { useState } from 'react';
import { useAuth } from './Auth';
import { FaUserCircle } from 'react-icons/fa';
import { signInWithGooglePopup, signOutUser } from '../Config/firebase';

export default function UserIcon() {

    const { currentUser } = useAuth();
    // State to manage the visibility of the context menu
    const [showMenu, setShowMenu] = useState(false);
  
    // Function to toggle the context menu visibility
    const toggleMenu = () => {
      setShowMenu(!showMenu);
    };


    const signIn = () => {
        setShowMenu(false);
        signInWithGooglePopup();
      };
    const signOut = () => {
        setShowMenu(false);
        signOutUser();
    };
  
    // Placeholder logout function - replace with your actual logout logic
    const logout = () => {
      console.log('Logging out...');
      // Add your logout logic here
    };

    // Extract the first letter of the displayName
    const userInitial = currentUser?.displayName ? currentUser.displayName.charAt(0).toUpperCase() : '';

  return (
    <div>
    {currentUser ? (
      <>
        <button onClick={toggleMenu} className="btn btn-dark" style={{ backgroundColor: 'transparent', borderColor: 'transparent' }}>
          <img src={currentUser.photoURL || ''} title={currentUser.displayName || ''} alt={currentUser.displayName || ''} style={{ borderRadius: '50%', width: 20, height: 20 }} />
        </button>
        {showMenu && (
          <div onClick={signOut} style={{ position: 'absolute', right: 20, top: 50, backgroundColor: 'transparent' }}>
            <button onClick={logout} className="btn btn-dark">Logout</button>
          </div>
        )}
      </>
    ) : (
      <button onClick={signIn} className="btn btn-dark" style={{ backgroundColor: 'transparent', borderColor: 'transparent' }}>
        <FaUserCircle size={20} />
      </button>
    )}
    </div>
  )
}
